export class User {
    id: number;
    id_anagrafica: number;
    certificazione: boolean;
    data_certificazione: string;
    username: string;
    password: string;
    nomeCompleto: string;
    codice_fiscale: string;
    email: string;
    pec: string;
    roles: any[];
    services: any[];
    detail: any;
    ultimoAccesso: string;
    ultimoAccessoLungo: string;
    responsabile_tributo: boolean;
    livelli_utenti_id: any;

    constructor(id: any = null){
	this.id = id;
	this.clear();
    }

    twoDigits(d: any) {
	if(0 <= d && d < 10) return "0" + d.toString();
	if(-10 < d && d < 0) return "-0" + (-1*d).toString();
	return d.toString();
    }

    clear(){
	let now = new Date(Date.now());
	this.id_anagrafica = 0;
	this.certificazione = false;
	this.data_certificazione = '';
	this.username = '';
	this.password = '';
	this.nomeCompleto = '';
	this.codice_fiscale = '';
	this.email = '';
	this.pec = '';
	this.roles = [];
	this.services = [];
	this.detail = null;
	this.ultimoAccesso = now.getFullYear() + "-" + this.twoDigits(1 + now.getMonth()) + "-" + this.twoDigits(now.getDate()) + " " + this.twoDigits(now.getHours()) + ":" + this.twoDigits(now.getMinutes()) + ":" + this.twoDigits(now.getSeconds());
	this.ultimoAccessoLungo = now.getFullYear() + "-" + this.twoDigits(1 + now.getMonth()) + "-" + this.twoDigits(now.getDate()) + " " + this.twoDigits(now.getHours()) + ":" + this.twoDigits(now.getMinutes()) + ":" + this.twoDigits(now.getSeconds());
	this.responsabile_tributo = false;
	this.livelli_utenti_id = null;
    }
};

export class UserByComune {
    userComplete: User;
    permissions: any;
    idMunicipalityAuthorized: any;
    saluto: string;
    ruolo: string;
    userLevelId: string;

    constructor(user: User = null){
	this.userComplete = user;
	this.clear();
    }

    clear(){
	this.userComplete = new User();
	this.permissions = null;
	this.idMunicipalityAuthorized = null;
	this.saluto = '';
	this.ruolo = '';
	this.userLevelId = null;
    }
};
